export interface IInvitationsState {
  readonly invitationsById?: any;
  readonly invitationIds?: any;
  readonly currentInvitationId?: any;
  readonly isLoading?: any;
  readonly hasLoaded?: any;
  readonly backendErrors?: any;
  readonly showAddInvitation?: any;
}

export interface IInvitationsSelector extends IInvitationsState {
  readonly currentInvitation?: any;
}

export enum InvitationsActionTypes {
  GET_INVITATION_REQUESTED = 'redux-app/invitations/GET_INVITATION_REQUESTED',
  GET_INVITATION_PENDING = 'redux-app/invitations/GET_INVITATION_PENDING',
  GET_INVITATION_SUCCESS = 'redux-app/invitations/GET_INVITATION_SUCCESS',
  GET_INVITATION_FAIL = 'redux-app/invitations/GET_INVITATION_FAIL',
  CREATE_ENROLMENT_REQUESTED = 'redux-app/invitations/CREATE_ENROLMENT_REQUESTED',
  CREATE_ENROLMENT_PENDING = 'redux-app/invitations/CREATE_ENROLMENT_PENDING',
  CREATE_ENROLMENT_SUCCESS = 'redux-app/invitations/CREATE_ENROLMENT_SUCCESS',
  CREATE_ENROLMENT_FAIL = 'redux-app/invitations/CREATE_ENROLMENT_FAIL',
}

export default null;
